export const languageSettings = {
  /* paginate: {
    previous: '<button class="btn btn-outline-primary">Anterior</button>',
    next: '<button class="btn btn-outline-primary">Siguiente</button>'
  }, */
  lengthMenu: 'Mostrar _MENU_ registros',
  info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
  infoEmpty: 'No hay registros disponibles',
  zeroRecords: 'No se encontraron coincidencias',
  emptyTable: 'No hay datos disponibles en la tabla',
  search: 'Buscar:',
  paginate: {
    first: "Primero",
    last: "Último",
    next: "->",
    previous: "<-",
  }
};